import type { OpUnitType } from "dayjs";

export enum GranularityNames {
    DAILY = "Daily",
    WEEKLY = "Weekly",
    MONTHLY = "Monthly",
}
export enum ComparisonMode {
    MOM = "mom",
    YOY = "yoy",
    POP = "pop",
}

export const granularityNameToMomentUnit: Record<GranularityNames, OpUnitType> = {
    Daily: "days",
    Weekly: "weeks",
    Monthly: "months",
};

export const granularityNameToMomentUnitSingular: Record<GranularityNames, OpUnitType> = {
    Daily: "day",
    Weekly: "week",
    Monthly: "month",
};
